module.exports = __webpack_public_path__ + "img/extended.79a9655d.png";